import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const SoftSkill = () => {
    const { t } = useTranslation();
  return (
    <div className="w-[90%] max-w-5xl my-10 mx-auto font-sans">
      <h2 className="text-center text-4xl font-bold text-gray-800 mb-8">
        {t("softSkill.title")}
      </h2>

      <div className="flex justify-around flex-wrap gap-5">

        {/* Box 1: Communication */}
        <Link
          to="/dashboard/student/soft-skills/voice-bot"
          className="flex-1 min-w-[280px] no-underline text-current block group"
        >
          <div className="h-full p-6 border border-gray-200 rounded-lg shadow-md bg-white
                          flex flex-col justify-center items-center
                          transition-all duration-200 ease-in-out
                          group-hover:-translate-y-1 group-hover:border-blue-700 group-hover:shadow-lg"
          >
            <h3 className="text-3xl font-bold text-blue-700 mb-2">
              {t("softSkill.communicationTitle")}
            </h3>
            <p className="text-base text-gray-600 text-center">
              {t("softSkill.communicationDesc")}
            </p>
          </div>
        </Link>

        {/* Box 2: Visual Assessment */}
        <Link
          to="/dashboard/student/soft-skills/image-assessment"
          className="flex-1 min-w-[280px] no-underline text-current block group"
        >
          <div className="h-full p-6 border border-gray-200 rounded-lg shadow-md bg-white
                          flex flex-col justify-center items-center
                          transition-all duration-200 ease-in-out
                          group-hover:-translate-y-1 group-hover:border-blue-700 group-hover:shadow-lg"
          >
            <h3 className="text-3xl font-bold text-blue-700 mb-2">
              {t("softSkill.visualTitle")}
            </h3>
            <p className="text-base text-gray-600 text-center">
             {t("softSkill.visualDesc")}
            </p>
          </div>
        </Link>

        {/* Box 3: Voice Quest */}
        <Link
          to="/dashboard/student/soft-skills/voice-quest"
          className="flex-1 min-w-[280px] no-underline text-current block group"
        >
          <div className="h-full p-6 border border-gray-200 rounded-lg shadow-md bg-white
                          flex flex-col justify-center items-center
                          transition-all duration-200 ease-in-out
                          group-hover:-translate-y-1 group-hover:border-blue-700 group-hover:shadow-lg"
          >
            <h3 className="text-3xl font-bold text-blue-700 mb-2">
              {t("softSkill.voiceQuestTitle")}
            </h3>
            <p className="text-base text-gray-600 text-center">
              {t("softSkill.voiceQuestDesc")}
            </p>
          </div>
        </Link>

        {/* Box 4: Sentence Builder */}
        <Link
          to="/dashboard/student/soft-skills/sentence-builder"
          className="flex-1 min-w-[280px] no-underline text-current block group"
        >
          <div className="h-full p-6 border border-gray-200 rounded-lg shadow-md bg-white
                          flex flex-col justify-center items-center
                          transition-all duration-200 ease-in-out
                          group-hover:-translate-y-1 group-hover:border-blue-700 group-hover:shadow-lg"
          >
            <h3 className="text-3xl font-bold text-blue-700 mb-2">
              {t("softSkill.sentenceBuilderTitle")}
            </h3>
            <p className="text-base text-gray-600 text-center">
             {t("softSkill.sentenceBuilderDesc")}
            </p>
          </div>
        </Link>

      </div>
    </div>
  );
}

export default SoftSkill;
